import React, { Component } from 'react'
import OverlayLoadingIndicator from 'components/common/OverlayLoadingIndicator'
import PropTypes from 'prop-types'
import styles from './loading-component.scss'

class LoadingComponent extends Component {
  render() {
    const { type, dark, light, loading, backgroundColor, content, containerStyle } = this.props

    const params = {
      dark,
      light,
      loading
    }

    if (loading) {
      return (
        <div
          style={{ backgroundColor: backgroundColor, ...containerStyle }}
          className={styles[`${type}-loading-container`]}
        >
          <OverlayLoadingIndicator {...params} />
          {content && <div
            className={
              [
                styles['loading-content'],
                dark ? styles['loading-content-dark'] : '',
                light ? styles['loading-content-light'] : ''
              ].filter(Boolean).join(' ')
            }
          >
            {content}
          </div>
          }
        </div>
      )
    } else {
      return null
    }
  }
}

LoadingComponent.defaultProps = {
  type: 'global',
  dark: false,
  light: false,
  loading: true,
  backgroundColor: 'transparent'
}

LoadingComponent.propTypes = {
  type: PropTypes.oneOf(['global', 'partial']),
  backgroundColor: PropTypes.string,
  dark: PropTypes.bool,
  light: PropTypes.bool,
  loading: PropTypes.bool,
  content: PropTypes.node,
  containerStyle: PropTypes.object
}

export default LoadingComponent
